var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16z",
    fill: "#000018",
    fillOpacity: 0.36
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.701 6.842h-7.403a5.463 5.463 0 00-5.456 5.456v7.404a5.463 5.463 0 005.456 5.456h7.404a5.463 5.463 0 005.456-5.456v-7.404a5.463 5.463 0 00-5.457-5.456zm3.614 12.86a3.614 3.614 0 01-3.613 3.614h-7.404a3.614 3.614 0 01-3.614-3.614v-7.404a3.614 3.614 0 013.614-3.614h7.404a3.614 3.614 0 013.613 3.614v7.404z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 11.263A4.743 4.743 0 0011.262 16 4.743 4.743 0 0016 20.737 4.743 4.743 0 0020.737 16 4.743 4.743 0 0016 11.263zm0 7.632a2.895 2.895 0 110-5.79 2.895 2.895 0 010 5.79zM21.881 11.298a1.135 1.135 0 11-2.27 0 1.135 1.135 0 012.27 0z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/media/instagram.c8d0be3e.svg";
export { SvgInstagram as ReactComponent };